import * as React from 'react';
import PropTypes from "prop-types";
import Select from "react-select";
import {get} from "lodash";
import Icon from "../../componentsReusable/Icon";
import {useStateWithCallbackLazy} from "use-state-with-callback";
import {useTranslation} from "react-i18next";
import {
  SUPPLIER_TYPE_ABAK_MOTO,
  SUPPLIER_TYPE_AFTER_MARKET,
  SUPPLIER_TYPE_AGRO_EFEKT,
  SUPPLIER_TYPE_ALCAR24,
  SUPPLIER_TYPE_ARGE_KRAKOW,
  SUPPLIER_TYPE_ARGE_KROSNO,
  SUPPLIER_TYPE_ARIS_AUTO,
  SUPPLIER_TYPE_AS_PL,
  SUPPLIER_TYPE_ATV_EXPERT,
  SUPPLIER_TYPE_AUTO_CENTRUM_MATUSIEWICZ,
  SUPPLIER_TYPE_AUTO_CZESCI_LIPIEC,
  SUPPLIER_TYPE_AUTO_EXPRESS,
  SUPPLIER_TYPE_AUTO_FORUM,
  SUPPLIER_TYPE_AUTO_GAMA,
  SUPPLIER_TYPE_AUTO_GROUP_POLSKA,
  SUPPLIER_TYPE_AUTO_MAR_TORUN,
  SUPPLIER_TYPE_AUTO_PARTS_100_AB,
  SUPPLIER_TYPE_AUTO_PLUS,
  SUPPLIER_TYPE_AUTO_WOJDYLA,
  SUPPLIER_TYPE_AUTOEURO,
  SUPPLIER_TYPE_AUTOIMPORT,
  SUPPLIER_TYPE_AUTOLAND,
  SUPPLIER_TYPE_AUTOMAT_CENTRUM_PL,
  SUPPLIER_TYPE_AUTOPARTNERHOLDING,
  SUPPLIER_TYPE_AUTOPARTNERSA,
  SUPPLIER_TYPE_AUTOS,
  SUPPLIER_TYPE_AUTOZATOKA,
  SUPPLIER_TYPE_BMW_DOBRZANSKI,
  SUPPLIER_TYPE_BMW_SMORAWINSKI,
  SUPPLIER_TYPE_BSL,
  SUPPLIER_TYPE_CAREX,
  SUPPLIER_TYPE_CERMOTOR,
  SUPPLIER_TYPE_DAN_CAR,
  SUPPLIER_TYPE_DARMA,
  SUPPLIER_TYPE_DOMINIK_JANICKI,
  SUPPLIER_TYPE_DUO_TRUCK,
  SUPPLIER_TYPE_DYNEX,
  SUPPLIER_TYPE_EDPOL,
  SUPPLIER_TYPE_ELIT,
  SUPPLIER_TYPE_EURO_PARTS,
  SUPPLIER_TYPE_EXACT_POLAND,
  SUPPLIER_TYPE_EXAMPLE_INTEGRATION,
  SUPPLIER_TYPE_GO_WEST,
  SUPPLIER_TYPE_GORDON,
  SUPPLIER_TYPE_GRAFTON_DIRT_BIKE,
  SUPPLIER_TYPE_HANDLOPEX,
  SUPPLIER_TYPE_HART,
  SUPPLIER_TYPE_HOLMER,
  SUPPLIER_TYPE_INTERCARS,
  SUPPLIER_TYPE_INTERNAL,
  SUPPLIER_TYPE_INTERPARTS,
  SUPPLIER_TYPE_INTERTEAM,
  SUPPLIER_TYPE_JADAR_AUTO,
  SUPPLIER_TYPE_JARO_FILTR,
  SUPPLIER_TYPE_KAWASAKI_PRO_BIKE,
  SUPPLIER_TYPE_KTD,
  SUPPLIER_TYPE_LARSSON,
  SUPPLIER_TYPE_LATEX,
  SUPPLIER_TYPE_MADEJSKI,
  SUPPLIER_TYPE_MARCO_MARINE,
  SUPPLIER_TYPE_MARTEX,
  SUPPLIER_TYPE_MERCEDES_BENZ_COM,
  SUPPLIER_TYPE_MMOT,
  SUPPLIER_TYPE_MOTO_ART_KIELCE,
  SUPPLIER_TYPE_MOTO_ART_WLOSZCZOWA,
  SUPPLIER_TYPE_MOTOGAMA,
  SUPPLIER_TYPE_MOTORES,
  SUPPLIER_TYPE_MOTOROL,
  SUPPLIER_TYPE_MP_AUTO,
  SUPPLIER_TYPE_MYTNIK,
  SUPPLIER_TYPE_OLEK_MOTOCYKLE,
  SUPPLIER_TYPE_OPOLTRANS,
  SUPPLIER_TYPE_OPONEO,
  SUPPLIER_TYPE_PARKER,
  SUPPLIER_TYPE_PARTNER_OPONY,
  SUPPLIER_TYPE_PARTS_TEAM,
  SUPPLIER_TYPE_POLAMEL,
  SUPPLIER_TYPE_PRO_BIKES,
  SUPPLIER_TYPE_PROFIAUTO,
  SUPPLIER_TYPE_RK_NIEDZIALEK,
  SUPPLIER_TYPE_RODON,
  SUPPLIER_TYPE_ROPA_POLSKA,
  SUPPLIER_TYPE_SAMLI,
  SUPPLIER_TYPE_SIEMIENIEC,
  SUPPLIER_TYPE_SKOPOL,
  SUPPLIER_TYPE_SPEED_FACTORY,
  SUPPLIER_TYPE_STACHMOT,
  SUPPLIER_TYPE_SUDER,
  SUPPLIER_TYPE_TD_AUTO_KEDZIERZYN,
  SUPPLIER_TYPE_TD_AUTO_OPOLE,
  SUPPLIER_TYPE_TIPTOPOL,
  SUPPLIER_TYPE_TM_PARTS,
  SUPPLIER_TYPE_TOMALA,
  SUPPLIER_TYPE_VANKING,
  SUPPLIER_TYPE_WAZ_CAR,
  SUPPLIER_TYPE_WILMAT,
  SUPPLIER_TYPE_X_TECH,
  SUPPLIER_TYPES_IMPORT_FROM_API,
  SUPPLIER_TYPES_IMPORT_FROM_FILE, 
  SUPPLIER_TYPE_TEMOT,
  SUPPLIER_MOTO_MAX,
} from "./SupplierTypes";
import exampleIntegrationLogo from "../../assets/img/integrations/suppliers/exampleIntegration.png";
import autoEuroLogo from "../../assets/img/integrations/suppliers/autoEuro.png";
import autolandLogo from "../../assets/img/integrations/suppliers/autoland.png";
import autopartnerholdingLogo from "../../assets/img/integrations/suppliers/autopartnerholding.png";
import autopartnersaLogo from "../../assets/img/integrations/suppliers/autopartnersa.png";
import carexLogo from "../../assets/img/integrations/suppliers/carex.png";
import jaroFiltrLogo from "../../assets/img/integrations/suppliers/jaro-filtr.png";
import mmotLogo from "../../assets/img/integrations/suppliers/mmot.png";
import autoZatokaLogo from "../../assets/img/integrations/suppliers/auto-zatoka.png";
import darmaLogo from "../../assets/img/integrations/suppliers/darma.png";
import motoresLogo from "../../assets/img/integrations/suppliers/motores.png";
import abakMotoLogo from "../../assets/img/integrations/suppliers/abak-moto.png";
import elitLogo from "../../assets/img/integrations/suppliers/elit.png";
import gordonLogo from "../../assets/img/integrations/suppliers/gordon.png";
import hartLogo from "../../assets/img/integrations/suppliers/hart.png";
import intercarsLogo from "../../assets/img/integrations/suppliers/intercars.png";
import interpartsLogo from "../../assets/img/integrations/suppliers/interparts.png";
import interteamLogo from "../../assets/img/integrations/suppliers/interteam.png";
import motorolLogo from "../../assets/img/integrations/suppliers/motorol.png";
import profiAutoLogo from "../../assets/img/integrations/suppliers/profiAuto.png";
import cerMotorLogo from "../../assets/img/integrations/suppliers/cerMotor.jpg";
import martexLogo from "../../assets/img/integrations/suppliers/martex.png";
import autoExpressLogo from "../../assets/img/integrations/suppliers/autoExpress.jpg";
import alcar24Logo from "../../assets/img/integrations/suppliers/alcar24.png";
import mytnikLogo from "../../assets/img/integrations/suppliers/mytnik.png";
import skopolLogo from "../../assets/img/integrations/suppliers/skopol.png";
import autoImportLogo from "../../assets/img/integrations/suppliers/autoImport.png";
import tipTopolLogo from "../../assets/img/integrations/suppliers/tiptopol.jpg";
import parkerLogo from "../../assets/img/integrations/suppliers/parker.png";
import marcoMarineLogo from "../../assets/img/integrations/suppliers/marco-marine.webp";
import stachmotLogo from "../../assets/img/integrations/suppliers/stachmot.jpg";
import autosLogo from "../../assets/img/integrations/suppliers/autos.png";
import handlopexLogo from "../../assets/img/integrations/suppliers/handlopex.png";
import holmerLogo from "../../assets/img/integrations/suppliers/holmer.png";
import ropaPolskaLogo from "../../assets/img/integrations/suppliers/ropa-polska.png";
import vankingLogo from "../../assets/img/integrations/suppliers/vanking.webp";
import rkNiedzialekLogo from "../../assets/img/integrations/suppliers/rkNiedzialek.png";
import duoTruckLogo from "../../assets/img/integrations/suppliers/duoTruck.png";
import agroEfektLogo from "../../assets/img/integrations/suppliers/agroEfekt.png";
import rodonLogo from "../../assets/img/integrations/suppliers/rodon.webp";
import madejskiLogo from "../../assets/img/integrations/suppliers/madejski.png";
import mpAutoLogo from "../../assets/img/integrations/suppliers/mpAuto.png";
import opoltransLogo from "../../assets/img/integrations/suppliers/opoltrans.png";
import suderLogo from "../../assets/img/integrations/suppliers/suder.png";
import autoCzesciLipiecLogo from "../../assets/img/integrations/suppliers/autoCzesciLipiec.png";
import tmPartsLogo from "../../assets/img/integrations/suppliers/tmParts.png";
import xTechLogo from "../../assets/img/integrations/suppliers/xTech.png";
import oponeoLogo from "../../assets/img/integrations/suppliers/oponeo.svg";
import bmwSmorawinskiLogo from "../../assets/img/integrations/suppliers/bmw-smorawinski.webp";
import bmwDobrzanskiLogo from "../../assets/img/integrations/suppliers/bmw-dobrzanski.png";
import jadarAutoLogo from "../../assets/img/integrations/suppliers/jadar-auto.jpg";
import automatCentrumPlLogo from "../../assets/img/integrations/suppliers/automat-centrum-pl.png";
import samliLogo from "../../assets/img/integrations/suppliers/samli.png";
import mercedesBenzComLogo from "../../assets/img/integrations/suppliers/mercedes-benz-com.png";
import motoArtWloszczowaLogo from "../../assets/img/integrations/suppliers/moto-art-wloszczowa.png";
import motoArtKielceLogo from "../../assets/img/integrations/suppliers/moto-art-kielce.png";
import bslLogo from "../../assets/img/integrations/suppliers/bsl.png";
import siemieniecLogo from "../../assets/img/integrations/suppliers/siemieniec.png";
import motogamaLogo from "../../assets/img/integrations/suppliers/motogama.png";
import ktdLogo from "../../assets/img/integrations/suppliers/ktd.png";
import polamelLogo from "../../assets/img/integrations/suppliers/polamel.png";
import tdAutoKedzierzynLogo from "../../assets/img/integrations/suppliers/td-auto-kedzierzyn.png";
import tdAutoOpoleLogo from "../../assets/img/integrations/suppliers/td-auto-opole.png";
import autoCentrumMatusiewiczLogo from "../../assets/img/integrations/suppliers/auto-centrum-matusiewicz.png";
import atvExpertLogo from "../../assets/img/integrations/suppliers/atv-expert.png";
import olekMotocykleLogo from "../../assets/img/integrations/suppliers/olek-motocykle.png";
import proBikesLogo from "../../assets/img/integrations/suppliers/pro-bikes.png";
import goWestLogo from "../../assets/img/integrations/suppliers/go-west.png";
import autoParts100AbLogo from "../../assets/img/integrations/suppliers/auto-parts-ab.jpg";
import speedFactoryLogo from "../../assets/img/integrations/suppliers/speed-factory.png";
import danCarLogo from "../../assets/img/integrations/suppliers/dan-car.png";
import kawasakiProBikeLogo from "../../assets/img/integrations/suppliers/kawasaki-pro-bike.jpg";
import graftonDirtBikeLogo from "../../assets/img/integrations/suppliers/grafton-dirt-bike.jpeg";
import latexLogo from "../../assets/img/integrations/suppliers/latex.png";
import argeKrakowLogo from "../../assets/img/integrations/suppliers/arge-krakow.png";
import argeKrosnoLogo from "../../assets/img/integrations/suppliers/arge-krosno.png";
import autoWojdylaLogo from "../../assets/img/integrations/suppliers/auto-wojdyla.png";
import autoPlusLogo from "../../assets/img/integrations/suppliers/auto-plus.png";
import wazCarLogo from "../../assets/img/integrations/suppliers/waz-car.png";
import exactPolandLogo from "../../assets/img/integrations/suppliers/exact-poland.png";
import afterMarketLogo from "../../assets/img/integrations/suppliers/after-market.png";
import autoMarTorunLogo from "../../assets/img/integrations/suppliers/auto-mar-torun.jpg";
import autoGamaLogo from "../../assets/img/integrations/suppliers/auto-gama.png";
import partsTeamLogo from "../../assets/img/integrations/suppliers/parts-team.png";
import euroPartsLogo from "../../assets/img/integrations/suppliers/euro-parts.png";
import edpolLogo from "../../assets/img/integrations/suppliers/edpol.png";
import dynexLogo from "../../assets/img/integrations/suppliers/dynex.png";
import arisAutoLogo from "../../assets/img/integrations/suppliers/aris-auto.png";
import tomalaLogo from "../../assets/img/integrations/suppliers/tomala.png";
import asPlLogo from "../../assets/img/integrations/suppliers/as-pl.png";
import autoForumLogo from "../../assets/img/integrations/suppliers/auto-forum.png";
import larssonLogo from "../../assets/img/integrations/suppliers/larsson.png";
import wilmatLogo from "../../assets/img/integrations/suppliers/wilmat.png";
import partnerOponyLogo from "../../assets/img/integrations/suppliers/partner-opony.png";
import autoGroupPolskaLogo from "../../assets/img/integrations/suppliers/auto-group-polska.png";
import temotLogo from "../../assets/img/integrations/suppliers/temot.png";
import motoMaxLogo from "../../assets/img/integrations/suppliers/moto-max.png";
import {TCD_VEHICLE_TYPE_CAR, TCD_VEHICLE_TYPE_TRUCK} from "../TecRmi/TecRmiVehicleTypeSuppliers";
import {useSelector} from "react-redux";

const webCatalogTecRmiSearch_cairoB2B = (url, tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => {
  return `${url}/tecdoc/${tcdVehicleType}/categories/${tcdMakeId}/${tcdRangeId}/${tcdTypeId}`
}
const webCatalogTecRmiSearch_nextis = (url, tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => {
  let typeName = 'osobowe'
  if(tcdVehicleType === TCD_VEHICLE_TYPE_TRUCK){
    typeName = 'ciezarowe'
  }

  return `${url}/pl/katalog/tecdoc/${typeName}/-/-/-/${tcdMakeId}/${tcdRangeId}/${tcdTypeId}`
}
const webCatalogTecRmiSearch_profiBiznes = (url, tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => {
  let typeName = null
  switch (tcdVehicleType) {
    case TCD_VEHICLE_TYPE_TRUCK: {
      typeName = 'uzytkowe'
      break;
    }
    case TCD_VEHICLE_TYPE_CAR:
    default: {
      typeName = 'osobowe'
      break;
    }
  }
  return `${url}/${typeName}/grupy/${tcdTypeId}`
}
const webCatalogTecRmiSearch_motoFirma = (url, tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => {
  let typeName = null
  switch (tcdVehicleType) {
    case TCD_VEHICLE_TYPE_TRUCK: {
      typeName = 'c'
      break;
    }
    case TCD_VEHICLE_TYPE_CAR:
    default: {
      typeName = 'o'
      break;
    }
  }
  return `${url}/make.asp?t=12&q=${typeName}${tcdTypeId}&pj=0`
}

export const SUPPLIERS_LIST = [
  {
    logo: exampleIntegrationLogo,
    name: 'Twoja Ulubiona Hurtownia',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={exampleIntegrationLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Twoja Ulubiona Hurtownia</span>
    </div>,
    value: SUPPLIER_TYPE_EXAMPLE_INTEGRATION,
    importFromApi: false,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: intercarsLogo,
    name: 'InterCars',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={intercarsLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">InterCars</span>
    </div>,
    value: SUPPLIER_TYPE_INTERCARS,
    importFromApi: true,
    importFromFile: true,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => {
      return `https://pl.e-cat.intercars.eu/pl/vehicle/${tcdVehicleType?.toUpperCase()}_${tcdTypeId}`
    }
  },
  {
    splitStagesAdding: true,
    logo: autopartnersaLogo,
    name: 'AutoPartner S.A.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autopartnersaLogo} style={{maxHeight: '25px'}}/>
      </div>
      <span className="ml-2">AutoPartner S.A.</span>
    </div>,
    value: SUPPLIER_TYPE_AUTOPARTNERSA,
    importFromApi: true,
    importFromFile: true,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => {
      if(tcdVehicleType === TCD_VEHICLE_TYPE_TRUCK){
        return null
      }
      return `https://apnext.eu/pl/katalog/tecdoc/osobowe/make/model/engine/${tcdMakeId}/${tcdRangeId}/${tcdTypeId}`
    }
  },
  {
    logo: gordonLogo,
    name: 'Gordon',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={gordonLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Gordon</span>
    </div>,
    value: SUPPLIER_TYPE_GORDON,
    importFromApi: true,
    importFromFile: true,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => {
      return `https://katalog.gordon.com.pl/partscatalogue/partsgroups.aspx?a=${tcdMakeId}&b=${tcdRangeId}&c=${tcdTypeId}`
    }
  },
  {
    logo: hartLogo,
    name: 'Hart',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={hartLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Hart</span>
    </div>,
    value: SUPPLIER_TYPE_HART,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => {
      return `https://store.hartphp.com.pl/TecDocCatalog/Silnik/${tcdTypeId}`
    }
  },
  {
    splitStagesAdding: true,
    logo: autolandLogo,
    name: 'AutoLand',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autolandLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">AutoLand</span>
    </div>,
    value: SUPPLIER_TYPE_AUTOLAND,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_cairoB2B('https://webterminal.auto-land.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: elitLogo,
    name: 'Elit Polska',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={elitLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Elit Polska</span>
    </div>,
    value: SUPPLIER_TYPE_ELIT,
    importFromApi: true,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    splitStagesAdding: true,
    logo: interteamLogo,
    name: 'Inter-Team',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={interteamLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Inter-Team</span>
    </div>,
    value: SUPPLIER_TYPE_INTERTEAM,
    importFromApi: true,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * do ponownej weryfikacji czy w przypadku ich katalogu da się wygenerować odpowiedni link
     */
  },
  {
    splitStagesAdding: true,
    logo: autopartnerholdingLogo,
    name: 'AutoPartner Holding',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autopartnerholdingLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">AutoPartner Holding</span>
    </div>,
    value: SUPPLIER_TYPE_AUTOPARTNERHOLDING,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_cairoB2B('https://katalog.autopartner.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: carexLogo,
    name: 'CAREX Nr 1 Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={carexLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">CAREX Nr 1 Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_CAREX,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://carex.profiauto.net', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: jaroFiltrLogo,
    name: 'Jaro Filtr',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={jaroFiltrLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Jaro Filtr</span>
    </div>,
    value: SUPPLIER_TYPE_JARO_FILTR,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://jaro-filtr.profiauto.net', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: autoZatokaLogo,
    name: 'Auto-Zatoka Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoZatokaLogo} style={{maxHeight: '20px'}} />
      </div>
      <span className="ml-2">Auto-Zatoka Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_AUTOZATOKA,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_cairoB2B('https://auto-zatoka.webterminal.com.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: autoEuroLogo,
    name: 'Auto Euro S.A.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoEuroLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto Euro S.A.</span>
    </div>,
    value: SUPPLIER_TYPE_AUTOEURO,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_cairoB2B('https://autoeuro.webterminal.com.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: mmotLogo,
    name: 'M-MOT Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={mmotLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">M-MOT Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_MMOT,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_cairoB2B('https://webterminal.m-mot.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: darmaLogo,
    name: 'Darma Sp. z o. o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={darmaLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Darma Sp. z o. o.</span>
    </div>,
    value: SUPPLIER_TYPE_DARMA,
    importFromApi: true,
    importFromFile: false,
    /**
     * webCatalogTecRmiSearch
     * Nie mogłem się dostać do ich katalogu
     * https://b2b.darma.com.pl/
     */
  },
  {
    splitStagesAdding: true,
    logo: abakMotoLogo,
    name: 'Abak Moto',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={abakMotoLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Abak Moto</span>
    </div>,
    value: SUPPLIER_TYPE_ABAK_MOTO,
    importFromApi: true,
    importFromFile: true,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://abak.profiauto.net', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: motoArtWloszczowaLogo,
    name: 'Moto Art Włoszczowa',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={motoArtWloszczowaLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Moto Art Włoszczowa</span>
    </div>,
    value: SUPPLIER_TYPE_MOTO_ART_WLOSZCZOWA,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://motoart.profiauto.net', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: motoArtKielceLogo,
    name: 'Moto Art Kielce',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={motoArtKielceLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Moto Art Kielce</span>
    </div>,
    value: SUPPLIER_TYPE_MOTO_ART_KIELCE,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://motoart.profiauto.net', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: interpartsLogo,
    name: 'InterParts',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={interpartsLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">InterParts</span>
    </div>,
    value: SUPPLIER_TYPE_INTERPARTS,
    importFromApi: true,
    importFromFile: true,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_cairoB2B('https://www.ipterminal.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    logo: profiAutoLogo,
    name: 'ProfiAuto',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={profiAutoLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">ProfiAuto</span>
    </div>,
    value: SUPPLIER_TYPE_PROFIAUTO,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: oponeoLogo,
    name: 'Oponeo S.A.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={oponeoLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Oponeo S.A.</span>
    </div>,
    value: SUPPLIER_TYPE_OPONEO,
    importFromApi: false,
    importFromFile: true,
  },
  {
    splitStagesAdding: false,
    logo: motorolLogo,
    name: 'Motorol',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={motorolLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Motorol</span>
    </div>,
    value: SUPPLIER_TYPE_MOTOROL,
    importFromApi: true,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     * https://ezamowienia.motorol.pl/
     */
  },
  {
    logo: cerMotorLogo,
    name: 'Cer Motor',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={cerMotorLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Cer Motor</span>
    </div>,
    value: SUPPLIER_TYPE_CERMOTOR,
    importFromApi: false,
    importFromFile: true,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_cairoB2B('https://webterminal.cermotor.com.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    logo: martexLogo,
    name: 'Martex Sp. z o. o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={martexLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Martex Sp. z o. o.</span>
    </div>,
    value: SUPPLIER_TYPE_MARTEX,
    importFromApi: false,
    importFromFile: true,

    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: autoExpressLogo,
    name: 'Auto Express',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoExpressLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto Express</span>
    </div>,
    value: SUPPLIER_TYPE_AUTO_EXPRESS,
    importFromApi: false,
    importFromFile: true,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://autoexpress.profiauto.net', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    logo: alcar24Logo,
    name: 'Alcar24',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={alcar24Logo} style={{maxHeight: '20px'}} />
      </div>
      <span className="ml-2">Alcar24</span>
    </div>,
    value: SUPPLIER_TYPE_ALCAR24,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: mytnikLogo,
    name: 'MYTNIK Sp. Jawna',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={mytnikLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">MYTNIK Sp. Jawna</span>
    </div>,
    value: SUPPLIER_TYPE_MYTNIK,
    importFromApi: false,
    importFromFile: true,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => `https://mytnik.com.pl/czesci-samochodowe/make/model/engine,p${tcdTypeId}`,
  },
  {
    logo: mercedesBenzComLogo,
    name: 'mercedes-benz.com',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={mercedesBenzComLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">mercedes-benz.com</span>
    </div>,
    value: SUPPLIER_TYPE_MERCEDES_BENZ_COM,
    importFromApi: false,
    importFromFile: false,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: bmwSmorawinskiLogo,
    name: 'BMW Smorawiński',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={bmwSmorawinskiLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">BMW Smorawiński</span>
    </div>,
    value: SUPPLIER_TYPE_BMW_SMORAWINSKI,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: bmwDobrzanskiLogo,
    name: 'BMW Dobrzańscy',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={bmwDobrzanskiLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">BMW Dobrzański</span>
    </div>,
    value: SUPPLIER_TYPE_BMW_DOBRZANSKI,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: skopolLogo,
    name: 'SKO-POL Sp. J.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={skopolLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">SKO-POL Sp. J.</span>
    </div>,
    value: SUPPLIER_TYPE_SKOPOL,
    importFromApi: true,
    importFromFile: true,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => `https://sklep.skopol.pl/partscatalogue/a,3-${tcdMakeId}-${tcdRangeId}-${tcdTypeId}-2.aspx`,
  },
  {
    logo: autoImportLogo,
    name: 'Auto-Import s.c. B.Śluzar G.Ociepka',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoImportLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto-Import s.c. B.Śluzar G.Ociepka</span>
    </div>,
    value: SUPPLIER_TYPE_AUTOIMPORT,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: tipTopolLogo,
    name: 'TIP-TOPOL Sp. z o. o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={tipTopolLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">TIP-TOPOL Sp. z o. o.</span>
    </div>,
    value: SUPPLIER_TYPE_TIPTOPOL,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: motoresLogo,
    name: 'Motores Sp. z o. o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={motoresLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Motores Sp. z o. o.</span>
    </div>,
    value: SUPPLIER_TYPE_MOTORES,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => `https://www.sklep.motores.pl/czesci-samochodowe/a/b/c,p${tcdTypeId}`,
  },
  {
    logo: stachmotLogo,
    name: 'Stachmot 1 S. A.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={stachmotLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Stachmot 1 S. A.</span>
    </div>,
    value: SUPPLIER_TYPE_STACHMOT,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: autosLogo,
    name: 'AUTOS Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autosLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">AUTOS Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_AUTOS,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     * https://sklep.autos.com.pl
     */
  },
  {
    logo: opoltransLogo,
    name: 'Opoltrans Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={opoltransLogo} style={{maxHeight: '20px'}} />
      </div>
      <span className="ml-2">Opoltrans Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_OPOLTRANS,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     * https://webterminal.opoltrans.com.pl
     */
  },
  {
    logo: suderLogo,
    name: 'Suder Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={suderLogo} style={{maxHeight: '30px'}} />
      </div>
      <span className="ml-2">Suder Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_SUDER,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     * https://www.suder.eu/pl/katalog-online/katalog-online
     */
  },
  {
    logo: parkerLogo,
    name: 'Parker Poland Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={parkerLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Parker Poland Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_PARKER,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: marcoMarineLogo,
    name: 'Marco Marine Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={marcoMarineLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Marco Marine Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_MARCO_MARINE,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: handlopexLogo,
    name: 'Handlopex S.A.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={handlopexLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Handlopex S.A.</span>
    </div>,
    value: SUPPLIER_TYPE_HANDLOPEX,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: holmerLogo,
    name: 'HOLMER Budowa Maszyn Spółka z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={holmerLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">HOLMER Budowa Maszyn Spółka z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_HOLMER,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: ropaPolskaLogo,
    name: 'Ropa Polska Sp. z o. o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={ropaPolskaLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Ropa Polska Sp. z o. o.</span>
    </div>,
    value: SUPPLIER_TYPE_ROPA_POLSKA,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    splitStagesAdding: true,
    logo: vankingLogo,
    name: 'VanKing Celkar Group sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={vankingLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">VanKing Celkar Group sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_VANKING,
    importFromApi: true,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: rkNiedzialekLogo,
    name: 'RK Niedziałek Hurtownia Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={rkNiedzialekLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">RK Niedziałek Hurtownia Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_RK_NIEDZIALEK,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: duoTruckLogo,
    name: 'DUO TRUCK S.C.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={duoTruckLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">DUO TRUCK S.C.</span>
    </div>,
    value: SUPPLIER_TYPE_DUO_TRUCK,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: agroEfektLogo,
    name: 'P.H.P. Agro-Efekt Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={agroEfektLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">P.H.P. Agro-Efekt Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_AGRO_EFEKT,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    splitStagesAdding: true,
    logo: rodonLogo,
    name: 'Rodon',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={rodonLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Rodon</span>
    </div>,
    value: SUPPLIER_TYPE_RODON,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_cairoB2B('https://strefa-klienta.rodon.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    logo: madejskiLogo,
    name: 'Madejski Sp. komandytowa',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={madejskiLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Madejski Sp. komandytowa</span>
    </div>,
    value: SUPPLIER_TYPE_MADEJSKI,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: jadarAutoLogo,
    name: 'Jadar Auto',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={jadarAutoLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Jadar Auto</span>
    </div>,
    value: SUPPLIER_TYPE_JADAR_AUTO,
    importFromApi: true,
    importFromFile: true,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_nextis('https://jadar-auto.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    logo: automatCentrumPlLogo,
    name: 'automat-centrum.pl',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={automatCentrumPlLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">automat-centrum.pl</span>
    </div>,
    value: SUPPLIER_TYPE_AUTOMAT_CENTRUM_PL,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: mpAutoLogo,
    name: 'MP AUTO Sp. Jawna',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={mpAutoLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">MP AUTO Sp. Jawna</span>
    </div>,
    value: SUPPLIER_TYPE_MP_AUTO,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    splitStagesAdding: true,
    logo: autoCzesciLipiecLogo,
    name: 'Auto Części Lipiec',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoCzesciLipiecLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto Części Lipiec</span>
    </div>,
    value: SUPPLIER_TYPE_AUTO_CZESCI_LIPIEC,
    importFromApi: true,
    importFromFile: false,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     * https://www.auto-czesci-lipiec.pl/
     */
  },
  {
    splitStagesAdding: true,
    logo: tmPartsLogo,
    name: 'TM Parts',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={tmPartsLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">TM Parts</span>
    </div>,
    value: SUPPLIER_TYPE_TM_PARTS,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_motoFirma('https://skleptmparts.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: xTechLogo,
    name: 'X-Tech Tarnowskie Góry',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={xTechLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">X-Tech Tarnowskie Góry</span>
    </div>,
    value: SUPPLIER_TYPE_X_TECH,
    importFromApi: true,
    importFromFile: false,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    splitStagesAdding: true,
    logo: samliLogo,
    name: 'Samli',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={samliLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Samli</span>
    </div>,
    value: SUPPLIER_TYPE_SAMLI,
    importFromApi: false,
    importFromFile: false,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    logo: bslLogo,
    name: 'BSL Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={bslLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">BSL Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_BSL,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    splitStagesAdding: true,
    logo: siemieniecLogo,
    name: 'Siemieniec',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={siemieniecLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Siemieniec</span>
    </div>,
    value: SUPPLIER_TYPE_SIEMIENIEC,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://siemieniec.profiauto.net', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: motogamaLogo,
    name: 'Motogama',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={motogamaLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Motogama</span>
    </div>,
    value: SUPPLIER_TYPE_MOTOGAMA,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_cairoB2B('https://motogama.webterminal.com.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: ktdLogo,
    name: 'KTD',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={ktdLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">KTD</span>
    </div>,
    value: SUPPLIER_TYPE_KTD,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_cairoB2B('https://ktd.webterminal.com.pl', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: polamelLogo,
    name: 'Polamel',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={polamelLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Polamel</span>
    </div>,
    value: SUPPLIER_TYPE_POLAMEL,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://polamel.profiauto.net', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: tdAutoKedzierzynLogo,
    name: 'TD Auto Kędzierzyn',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={tdAutoKedzierzynLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">TD Auto Kędzierzyn</span>
    </div>,
    value: SUPPLIER_TYPE_TD_AUTO_KEDZIERZYN,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://tdauto.profiauto.net', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: tdAutoOpoleLogo,
    name: 'TD Auto Opole',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={tdAutoOpoleLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">TD Auto Opole</span>
    </div>,
    value: SUPPLIER_TYPE_TD_AUTO_OPOLE,
    importFromApi: true,
    importFromFile: false,
    webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://tdauto.profiauto.net', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  },
  {
    splitStagesAdding: true,
    logo: autoCentrumMatusiewiczLogo,
    name: 'Auto Centrum Matusiewicz',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoCentrumMatusiewiczLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto Centrum Matusiewicz</span>
    </div>,
    value: SUPPLIER_TYPE_AUTO_CENTRUM_MATUSIEWICZ,
    importFromApi: true,
    importFromFile: false,
  },
  {
    logo: atvExpertLogo,
    name: 'ATV Expert',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={atvExpertLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">ATV Expert</span>
    </div>,
    value: SUPPLIER_TYPE_ATV_EXPERT,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: olekMotocykleLogo,
    name: 'Olek Motocykle',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={olekMotocykleLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Olek Motocykle</span>
    </div>,
    value: SUPPLIER_TYPE_OLEK_MOTOCYKLE,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: proBikesLogo,
    name: 'Pro Bikes',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={proBikesLogo} style={{maxHeight: '30px'}} />
      </div>
      <span className="ml-2">Pro Bikes</span>
    </div>,
    value: SUPPLIER_TYPE_PRO_BIKES,
    importFromApi: false,
    importFromFile: true,
  },
  {
    splitStagesAdding: true,
    logo: goWestLogo,
    name: 'Go West',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={goWestLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Go West</span>
    </div>,
    value: SUPPLIER_TYPE_GO_WEST,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: autoParts100AbLogo,
    name: 'Auto Parts 100 AB',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoParts100AbLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Auto Parts 100 AB</span>
    </div>,
    value: SUPPLIER_TYPE_AUTO_PARTS_100_AB,
    importFromApi: true,
    importFromFile: false,
  },
  {
    logo: speedFactoryLogo,
    name: 'Speed Factory MX',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={speedFactoryLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Speed Factory MX</span>
    </div>,
    value: SUPPLIER_TYPE_SPEED_FACTORY,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: kawasakiProBikeLogo,
    name: 'Kawasaki - Pro Bike Sp. z o.o.',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={kawasakiProBikeLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Kawasaki - Pro Bike</span>
    </div>,
    value: SUPPLIER_TYPE_KAWASAKI_PRO_BIKE,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    splitStagesAdding: true,
    logo: danCarLogo,
    name: 'Dan-Car',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={danCarLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Dan-Car</span>
    </div>,
    value: SUPPLIER_TYPE_DAN_CAR,
    importFromApi: true,
    importFromFile: false,
  },
  {
    logo: graftonDirtBikeLogo,
    name: 'Speed Factory MX',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={graftonDirtBikeLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">dirtbike.pl</span>
    </div>,
    value: SUPPLIER_TYPE_GRAFTON_DIRT_BIKE,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: latexLogo,
    name: 'Latex Opony',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={latexLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Latex Opony</span>
    </div>,
    value: SUPPLIER_TYPE_LATEX,
    importFromApi: false,
    importFromFile: true,
  },
  {
    splitStagesAdding: true,
    logo: argeKrakowLogo,
    name: 'Arge Kraków',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={argeKrakowLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Arge Kraków</span>
    </div>,
    value: SUPPLIER_TYPE_ARGE_KRAKOW,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: argeKrosnoLogo,
    name: 'Arge Krosno',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={argeKrosnoLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Arge Krosno</span>
    </div>,
    value: SUPPLIER_TYPE_ARGE_KROSNO,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: autoWojdylaLogo,
    name: 'Auto Wojdyła',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoWojdylaLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto Wojdyła</span>
    </div>,
    value: SUPPLIER_TYPE_AUTO_WOJDYLA,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: autoPlusLogo,
    name: 'Auto Plus',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoPlusLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto Plus</span>
    </div>,
    value: SUPPLIER_TYPE_AUTO_PLUS,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: wazCarLogo,
    name: 'Waz Car',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={wazCarLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Waz Car</span>
    </div>,
    value: SUPPLIER_TYPE_WAZ_CAR,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: exactPolandLogo,
    name: 'Exact Poland',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={exactPolandLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Exact Poland</span>
    </div>,
    value: SUPPLIER_TYPE_EXACT_POLAND,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: afterMarketLogo,
    name: 'After Market',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={afterMarketLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">After Maket</span>
    </div>,
    value: SUPPLIER_TYPE_AFTER_MARKET,
    importFromApi: true,
    importFromFile: false,
  },
  // {
  //   splitStagesAdding: true,
  //   logo: autoMarTwardogoraLogo,
  //   name: 'Auto-Mar',
  //   label: <div className="d-flex flex-nowrap align-items-center">
  //     <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
  //       <img src={autoMarTwardogoraLogo} style={{maxHeight: '25px'}} />
  //     </div>
  //     <span className="ml-2">Auto-Mar</span>
  //   </div>,
  //   value: SUPPLIER_TYPE_AUTO_MAR_TWARDOGORA,
  //   importFromApi: true,
  //   importFromFile: false,
  //   webCatalogTecRmiSearch: (tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId) => webCatalogTecRmiSearch_profiBiznes('https://automar.profiauto.net/', tcdVehicleType, tcdMakeId, tcdRangeId, tcdTypeId),
  // },
  {
    splitStagesAdding: true,
    logo: autoMarTorunLogo,
    name: 'Auto-Mar',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoMarTorunLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto-Mar</span>
    </div>,
    value: SUPPLIER_TYPE_AUTO_MAR_TORUN,
    importFromApi: true,
    importFromFile: false,
  },
  {
    logo: autoGamaLogo,
    name: 'Auto Gama',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoGamaLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto Gama</span>
    </div>,
    value: SUPPLIER_TYPE_AUTO_GAMA,
    importFromApi: false,
    importFromFile: true,
    /**
     * webCatalogTecRmiSearch
     * Nie sprawdzałem ich katalogu
     */
  },
  {
    splitStagesAdding: true,
    logo: partsTeamLogo,
    name: 'Parts Team',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={partsTeamLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Parts Team</span>
    </div>,
    value: SUPPLIER_TYPE_PARTS_TEAM,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: euroPartsLogo,
    name: 'Centrum motoryzacyjne Banino - Euro Parts',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={euroPartsLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Centrum motoryzacyjne Banino - Euro Parts</span>
    </div>,
    value: SUPPLIER_TYPE_EURO_PARTS,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: edpolLogo,
    name: 'Edpol',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={edpolLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Edpol</span>
    </div>,
    value: SUPPLIER_TYPE_EDPOL,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: dynexLogo,
    name: 'Dynex',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={dynexLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Dynex</span>
    </div>,
    value: SUPPLIER_TYPE_DYNEX,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: arisAutoLogo,
    name: 'Aris Auto',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={arisAutoLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Aris Auto</span>
    </div>,
    value: SUPPLIER_TYPE_ARIS_AUTO,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: tomalaLogo,
    name: 'Tomala',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={tomalaLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Tomala</span>
    </div>,
    value: SUPPLIER_TYPE_TOMALA,
    importFromApi: true,
    importFromFile: false,
  },
  {
    logo: asPlLogo,
    name: 'AS',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={asPlLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">AS-PL Sp. z o.o.</span>
    </div>,
    value: SUPPLIER_TYPE_AS_PL,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: autoForumLogo,
    name: 'Auto Forum',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoForumLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto Forum</span>
    </div>,
    value: SUPPLIER_TYPE_AUTO_FORUM,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: larssonLogo,
    name: 'Larsson',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={larssonLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Larsson</span>
    </div>,
    value: SUPPLIER_TYPE_LARSSON,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: wilmatLogo,
    name: 'Wilmat',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={wilmatLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Wilmat</span>
    </div>,
    value: SUPPLIER_TYPE_WILMAT,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: partnerOponyLogo,
    name: 'Partner Opony',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={partnerOponyLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Partner Opony</span>
    </div>,
    value: SUPPLIER_TYPE_PARTNER_OPONY,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: autoGroupPolskaLogo,
    name: 'Auto Group Polska',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={autoGroupPolskaLogo} style={{maxHeight: '25px'}} />
      </div>
      <span className="ml-2">Auto Group Polska</span>
    </div>,
    value: SUPPLIER_TYPE_AUTO_GROUP_POLSKA,
    importFromApi: false,
    importFromFile: true,
  },
  {
    splitStagesAdding: true,
    logo: temotLogo,
    name: 'Temot',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={temotLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Temot</span>
    </div>,
    value: SUPPLIER_TYPE_TEMOT,
    importFromApi: true,
    importFromFile: false,
  },
  {
    splitStagesAdding: true,
    logo: motoMaxLogo,
    name: 'Moto-Max',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center" style={{width: '135px'}}>
        <img src={motoMaxLogo} style={{maxHeight: '25px', maxWidth: '100%'}} />
      </div>
      <span className="ml-2">Moto-Max</span>
    </div>,
    value: SUPPLIER_MOTO_MAX,
    importFromApi: true,
    importFromFile: false,
  },

  {
    logo: null,
    name: 'Dominik Janicki (NIP: 6961460177)',
    label: <div className="d-flex flex-nowrap align-items-center">
      Dominik Janicki (NIP: 6961460177)
    </div>,
    value: SUPPLIER_TYPE_DOMINIK_JANICKI,
    importFromApi: false,
    importFromFile: true,
  },
  {
    logo: null,
    name: '-- Własne przyjęcie wewnętrzne --',
    label: <div className="d-flex flex-nowrap align-items-center">
      <div className="d-flex align-items-center justify-content-center">
        -- Własne przyjęcie wewnętrzne --
      </div>
    </div>,
    value: SUPPLIER_TYPE_INTERNAL,
    importFromApi: false,
    importFromFile: true,
  },
];

function SupplierTypeSelect(props) {
  const { t } = useTranslation('supplier_select')
  const LOCAL_STORAGE_KEY_NAME = 'suppliers-favorite'
  const suppliersIntegrated = useSelector(state => state.suppliers)
  const [value, setValue] = useStateWithCallbackLazy(props.value);
  const test = false

  const getFavorites = () => {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_NAME) ?? '{}')
  }

  const removeFromFavorite = (key) => {
    const favorites = getFavorites()

    delete favorites[key]

    localStorage.setItem(LOCAL_STORAGE_KEY_NAME, JSON.stringify(favorites))

    const _value = value
    setValue(null, () => {
      setValue(_value)
    })
  }

  const increaseFavorite = (key) => {
    const favorites = getFavorites()

    if(!favorites[key]){
      favorites[key] = 0
    }

    favorites[key]++

    localStorage.setItem(LOCAL_STORAGE_KEY_NAME, JSON.stringify(favorites))
  }
console.log('suppliersIntegrated', suppliersIntegrated)
  const getOptions = () => {
    const favorites = getFavorites()

    return SUPPLIERS_LIST
      .map(supplierType => {
        if(
          (
            (props.type === SUPPLIER_TYPES_IMPORT_FROM_FILE && supplierType.importFromFile)
            || (props.type === SUPPLIER_TYPES_IMPORT_FROM_API && supplierType.importFromApi)
          )
          && (
            !props.showOnlyIntegrationCreated || suppliersIntegrated.find(supplierIntegrated => supplierIntegrated.type === supplierType.value)
          )
        ){
          return {
            ...supplierType,
            isFavorite: supplierType.value in favorites,
            label: <div className="d-flex flex-row flex-nowrap align-items-center justify-content-between">
              {supplierType.label}
              <div>
                {supplierType.value in favorites && <Icon
                  tooltip={t('remove_from_favorites')}
                  className="fas fa-star text-warning cursor-pointer"
                  onClick={e => {
                    e.stopPropagation()
                    removeFromFavorite(supplierType.value)
                  }}
                />}
              </div>
            </div>
          }
        }

        return false;
      })
      .filter(v => v)
      .sort((a, b) => {
        const aOrder = get(favorites, a.value) || 0
        const bOrder = get(favorites, b.value) || 0

        return aOrder > bOrder ? -1 : 1
      })
  }

  const onChange = (selectedOptions) => {
    if (props.isMulti) {
      const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
      props.onChange(values);
      setValue(values);
      if (selectedOptions) {
        selectedOptions.forEach(option => increaseFavorite(option.value));
      }
    } else {
      const value = selectedOptions ? selectedOptions.value : null;
      props.onChange(value);
      setValue(value);
      if (value) {
        increaseFavorite(value);
      }
    }
  };

  return (
    <Select
      classNamePrefix="react-select"
      className="w-100"
      placeholder={t('common:select.placeholder')}
      options={test ? [] : getOptions()}
      value={SUPPLIERS_LIST.find(option => option.value === value)}
      onChange={onChange}
      isMulti={props.isMulti}
    />
  );
}

SupplierTypeSelect.defaultProps = {
  isDisabled: false,
  isMulti: false,
  options: [],
  showOnlyIntegrationCreated: false,
};

SupplierTypeSelect.propTypes = {
  isDisabled: PropTypes.bool,
  showOnlyIntegrationCreated: PropTypes.bool,
  type: PropTypes.oneOf([SUPPLIER_TYPES_IMPORT_FROM_FILE, SUPPLIER_TYPES_IMPORT_FROM_API]).isRequired,
  options: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  isMulti: PropTypes.bool
};

export default SupplierTypeSelect;
